// ABOUTME: Sends leftover CRA marketing routes to the static site on rayze.xyz.
// ABOUTME: Used when an old in-app path should not stay on app.rayze.xyz.

import { useEffect } from 'react';
import { MARKETING_ORIGIN } from '../config/hosts';

export default function MarketingRedirect({ path = '/' }) {
  useEffect(() => {
    window.location.replace(`${MARKETING_ORIGIN}${path}`);
  }, [path]);
  return null;
}
